export enum FieldType {
  TIME = <any>'TIME',
  TEXT = <any>'TEXT',
  RADIO = <any>'RADIO',
  MULTI = <any>'MULTI',
  ATTACHMENT = <any>'ATTACHMENT',
  NUMERICAL = <any>'NUMERICAL'
}
